// src/features/locker-types/components/LockerTypeCreate.tsx

import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
  required,
  useTranslate,
  useNotify,
  useRedirect,
  usePermissions,
} from 'react-admin';
import { AddBox as AddBoxIcon } from '@mui/icons-material';

import { MyToolbar } from '../../../components/forms/MyToolbar';
import { MyFormContainer } from '../../../components/forms/MyFormContainer';
import { 
  CenteredFormLayout,
  MyFormSection 
} from '../../../components/forms/MyFormLayout';

import { useLockerTypeValidation } from '../hooks/useLockerTypeValidation';
import { LockerTypeFormData, prepareLockerTypeForAPI } from '../types';

export const LockerTypeCreate: React.FC = () => {
  const translate = useTranslate();
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions: role } = usePermissions();
  
  const { validateName, validateDescription, validateHotelId } = useLockerTypeValidation();

  const transform = (data: LockerTypeFormData) => prepareLockerTypeForAPI(data);
  
  const handleSuccess = () => {
    notify(
      translate('resources.locker-types.notifications.created', 'Tipo de Taquilla creado con éxito'), 
      { type: 'success' }
    );
    redirect('/locker-types');
  };
  
  const handleError = (error: any) => {
    console.error('Error creating locker type:', error);
    notify(
      error.message || translate('resources.locker-types.errors.create', 'Error al crear el tipo de taquilla'), 
      { type: 'error' }
    );
  };
  
  const handleCancel = () => redirect('/locker-types');

  return (
    <Create
      title={translate('resources.locker-types.titles.create', 'Crear Tipo de Taquilla')}
      transform={transform}
      mutationOptions={{ onSuccess: handleSuccess, onError: handleError }}
      redirect={false}
    >
      <MyFormContainer maxWidth="lg">
        <SimpleForm
          toolbar={
            <MyToolbar 
              onCancel={handleCancel} 
              resource="locker-types" 
              showDelete={false} 
            />
          }
        >
          <CenteredFormLayout>
            <MyFormSection
              title={translate('resources.locker-types.sections.new_type_title', 'Nuevo Tipo de Taquilla')}
              subtitle={translate(
                'resources.locker-types.sections.new_type_subtitle', 
                'Complete los datos para crear un nuevo tipo de taquilla'
              )}
              icon={<AddBoxIcon />}
              variant="outlined"
            >
             
                <ReferenceInput 
                  source="hotelId" 
                  reference="hotels" 
                  label={translate('resources.locker-types.fields.hotel', 'Hotel')}
                  fullWidth
                  disabled={role !== 'SuperAdmin'}
                >
                  <SelectInput 
                    optionText="name"
                    validate={[required(), validateHotelId]}
                    fullWidth
                    variant="outlined"
                  
                  />
                </ReferenceInput>

                <TextInput
                  source="name"
                  label={translate('resources.locker-types.fields.name', 'Nombre del Tipo')}
                  validate={[required(), validateName]}
                  fullWidth
                  variant="outlined"
                 
                />

                <TextInput
                  source="description"
                  label={translate('resources.locker-types.fields.description', 'Descripción')}
                  validate={validateDescription}
                  fullWidth
                  multiline
                  rows={4}
                  variant="outlined"
                  
                />

              
          
            </MyFormSection>
          </CenteredFormLayout>
        </SimpleForm>
      </MyFormContainer>
    </Create>
  );
};

export default LockerTypeCreate;